import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import scrollEffect from "./lib/scrollEffect.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import '@/scss/design.scss';
// import topValidation from 'top-validation';
// import { isPage, isMobile } from "./lib/util";
// import observer from "./lib/observer.js";

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
  scrollEffect();
  gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

  /*-------------------------------------------------------------------------------
    nav button
  --------------------------------------------------------------------------------*/
  document.querySelectorAll('.trigger-btn').forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault();

      const navUnit = document.querySelector('.nav-unit');
      const navList = document.querySelector('.nav-list');
      const navItems = navList.querySelectorAll('li');
      const hiddenWraps = document.querySelectorAll('.hidden-wrap');

      // トグル状態を判定
      const isActive = button.classList.toggle('is-active');
      navUnit.classList.toggle('is-active', isActive);
      navList.classList.toggle('is-active', isActive);

      if (isActive) {
        // 順番に li に is-show を付与
        const itemDelay = 150; // 各 li の出現間隔
        const initialDelay = 100; // 最初の遅延

        navItems.forEach((item, index) => {
          setTimeout(() => {
            item.classList.add('is-show');
          }, initialDelay + index * itemDelay);
        });

        // li の最後が出現した後に hidden-wrap に is-show を一斉付与
        const totalDelay = initialDelay + (navItems.length - 1) * itemDelay + 150; // バッファ
        setTimeout(() => {
          hiddenWraps.forEach((wrap) => {
            wrap.classList.add('is-show');
          });
        }, totalDelay);

      } else {
        // 閉じるときは hidden-wrap を先に消す
        setTimeout(() => {
          hiddenWraps.forEach((wrap) => {
            wrap.classList.remove('is-show');
          });
        }, 500); // 閉じる遅延

        setTimeout(() => {
          navItems.forEach((item) => {
            item.classList.remove('is-show');
          });
        }, 500); // 閉じる遅延
      }
    });
  });

  /*-------------------------------------------------------------------------------
    cta parallax
  --------------------------------------------------------------------------------*/
  // 画面幅によって移動量を切り替え
  const yValue = window.matchMedia("(max-width: 768px)").matches ? -100 : -180;

  gsap.to(".cta-parallax-item", {
    y: yValue,
    ease: "none",
    scrollTrigger: {
      trigger: ".footer",
      start: "top bottom",
      end: "bottom bottom",
      scrub: true,
    }
  });

  /*-------------------------------------------------------------------------------
    scroll reveal
  --------------------------------------------------------------------------------*/
  gsap.utils.toArray(".js-scroll-reveal").forEach((el) => {
    let delayTime = 0;

    // 同じ親の子要素を取得
    const siblings = Array.from(el.parentNode.children);
    const elIndex = siblings.indexOf(el);

    // 前後どちらかの兄弟要素に .cmn-vertical-ttl があるかチェック
    if (
      (siblings[elIndex - 1] && siblings[elIndex - 1].classList.contains("cmn-vertical-ttl")) ||
      (siblings[elIndex + 1] && siblings[elIndex + 1].classList.contains("cmn-vertical-ttl"))
    ) {
      delayTime = 0.8; // 遅延
    }

    gsap.from(el, {
      opacity: 0,
      y: 50,
      duration: 1,
      delay: delayTime,
      ease: "power1.out",
      scrollTrigger: {
        trigger: el,
        start: "top 87%",
        toggleActions: "play none none none",
        once: true
      }
    });
  });



  /*-------------------------------------------------------------------------------
    horizontal list scroll effects
  --------------------------------------------------------------------------------*/
  const items = document.querySelectorAll('.maker-list li');

  if (items.length > 0) {
    ScrollTrigger.create({
      trigger: '.maker-list',
      start: 'top 80%',
      once: true,
      onEnter: () => {
        items.forEach((item, i) => {
          setTimeout(() => {
            item.classList.add('is-active');
          }, i * 100); // ← 0.2秒ずつ順番に付与
        });
      }
    });
  }

  /*-------------------------------------------------------------------------------
    image reveal
  --------------------------------------------------------------------------------*/
  gsap.utils.toArray(".js-scroll-visual").forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top 85%",
      onEnter: () => el.classList.add("is-show"),
    })
  })

}); // document.addEventListener

/*-------------------------------------------------------------------------------
  loading
--------------------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  const loading = document.getElementById("loading");
  const logoSvg = document.querySelector(".logo-svg");
  const mainCopy = document.querySelector(".main-copy");
  const subCopy = document.querySelector(".sub-copy");

  // 初回訪問時だけローディングを表示
  if (!sessionStorage.getItem("visited")) {
    sessionStorage.setItem("visited", "true");
    loading.style.display = "flex";
  } else {
    loading.style.display = "none";
    mainCopy.classList.add("is-show");
    subCopy.classList.add("is-show");
    return;
  }

  // 0.8秒後にロゴにフェードアウトクラスを付与
  setTimeout(() => {
    logoSvg.classList.add("fade-out");

    // 少し遅らせてローディング全体をフェードアウト
    setTimeout(() => {
      gsap.to(loading, {
        opacity: 0,
        duration: 1.5,
        onComplete: () => {
          loading.style.display = "none";

          // GSAPタイムラインで順番にクラス付与
          const tl = gsap.timeline();
          tl.add(() => mainCopy.classList.add("is-show"));
          tl.add(() => subCopy.classList.add("is-show"), "+=0.8");
        }
      });
    }, 1000);
  }, 1800);
});

/*-------------------------------------------------------------------------------
  text animation
--------------------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".js-txt-anime");

  const wrapTextWithSpan = (node, countRef) => {
    const fragment = document.createDocumentFragment();

    if (node.nodeType === Node.TEXT_NODE) {
      [...node.textContent].forEach((char) => {
        if (char === "\n") {
          fragment.appendChild(document.createElement("br"));
        } else {
          const span = document.createElement("span");
          span.innerHTML = char === " " ? "&nbsp;" : char;
          span.style.transitionDelay = `${countRef.count * 0.05}s`;
          fragment.appendChild(span);
          countRef.count++;
        }
      });
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const clone = node.cloneNode(false); // <span> だけ複製（中身なし）
      node.childNodes.forEach((child) => {
        clone.appendChild(wrapTextWithSpan(child, countRef)); // 再帰処理
      });
      fragment.appendChild(clone);
    }

    return fragment;
  };

  targets.forEach((el) => {
    const textNodes = Array.from(el.childNodes);
    el.innerHTML = "";

    const countRef = { count: 0 };

    textNodes.forEach((node) => {
      const wrapped = wrapTextWithSpan(node, countRef);
      el.appendChild(wrapped);
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.2,
    }
  );

  document.querySelectorAll(".js-txt-anime").forEach((el) => {
    observer.observe(el);
  });
});

/*-------------------------------------------------------------------------------
  faq button
--------------------------------------------------------------------------------*/
jQuery(function($) {
  $('.faq-btn').on('click', function() {
    const $answer = $(this).find('.answer-item');
    const $icon = $(this).find('.faq-icon-item');

    $answer.stop().slideToggle(400);
    $icon.toggleClass('is-active');
  });
});

/*-------------------------------------------------------------------------------
  split Text Button
--------------------------------------------------------------------------------*/
let splitTarget = document.querySelectorAll('.js-splitTextButton .js-splitText');

splitTarget.forEach((target) => {
  if (!target.classList.contains('is-active')) {

    // 子ノードを分解して「テキスト」と「imgなどのノード」を分離
    let textContent = "";
    let otherNodesHTML = "";

    target.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        textContent += node.textContent;
      } else {
        otherNodesHTML += node.outerHTML; // imgタグなど
      }
    });

    // --- ここから元のsplit処理 ---
    let newText = "";
    textContent.split("").forEach((char) => {
      if (char === " ") {
        newText += '<span style="display:inline-block; width:0.5em;">&nbsp;</span>';
      } else {
        newText += `<span>${char}</span>`;
      }
    });

    let newTextBefore = `<div class="before">${newText}</div>`;
    let newTextAfter  = `<div class="after">${newText}</div>`;

    // アイコンは最後にそのまま結合
    let wrap = `
      <span class="split_txt_wrap">
        ${newTextBefore + newTextAfter}
      </span>
      ${otherNodesHTML}
    `;

    target.innerHTML = wrap;
  }
});

var winW = window.innerWidth;
var spW = 768;

if (winW >= spW) {

  /* ターゲットにホバーした時の動き */
  let splitTargetButton = document.querySelectorAll('.js-splitTextButton');//ターゲットのボタン
  splitTargetButton.forEach((target)=>{
    if(!target.classList.contains('is-active')){//ターゲットが'is-active'クラスを持っていない場合
      let beforeSpan = target.querySelector('.before').querySelectorAll('span');//beforeの中にあるspanタグを全取得
      let afterSpan = target.querySelector('.after').querySelectorAll('span');//afterの中にあるspanタグを全取得
      target.addEventListener('mouseenter',()=>{//ホバーしたとき
        gsap.to(beforeSpan,{y:'-100%',stagger:.04,ease:"power2.out"})//0.03秒おきに各spanタグをy軸上に移動
        gsap.to(afterSpan,{y:'0%',stagger:.04,ease:"power2.out"})
      })
      target.addEventListener('mouseleave',()=>{//ホバーが外れたとき
        gsap.to(beforeSpan,{y:'0%',stagger:.04,ease:"power2.out"})
        gsap.to(afterSpan,{y:'100%',stagger:.04,ease:"power2.out"})
      })
    }
  })
}

/*-------------------------------------------------------------------------------
  Lenis
--------------------------------------------------------------------------------*/
const lenis = new Lenis()
function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}
requestAnimationFrame(raf)


/*-------------------------------------------------------------------------------
  slider
--------------------------------------------------------------------------------*/
const caseSwiper = new Swiper('.case-swiper', {
  loop: true,
  slidesPerView: 4,
  speed: 5500,

  autoplay: {
    delay: 0,
  },

  breakpoints: {
    0: {              // 〜768px
      slidesPerView: 1,
    },
    769: {            // 769px〜
      slidesPerView: 4,
    }
  },

});


/*-------------------------------------------------------------------------------
  service about effect
--------------------------------------------------------------------------------*/
gsap.utils.toArray('.service-about-block').forEach(section => {
  // 768px以下ではピン止めをしない
  if (window.matchMedia("(min-width: 769px)").matches) {
    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      pin: true,
      pinSpacing: false
    });
  }
});

// GSAPとScrollTriggerを登録
gsap.registerPlugin(ScrollTrigger);

// デバイスの幅に応じて異なる値を設定する関数
function getParallaxYValue() {
  if (window.matchMedia("(max-width: 768px)").matches) {
    // スマホサイズのとき
    return -50; // スマホ用のY値
  } else {
    // パソコンサイズのとき
    return -200; // パソコン用のY値
  }
}

// 各要素に対してパララックスアニメーションを設定
gsap.utils.toArray('.js-parallax').forEach(wrap => {
  const y = getParallaxYValue(); // デバイスに応じたY値を取得

  gsap.to(wrap, {
    y: y,
    scrollTrigger: {
      trigger: wrap,
      start: 'top bottom',
      end: 'bottom top',
      scrub: 10,
    }
  });
});

// .service-img-sub-wrapを上方向にスライドさせる処理を追加
gsap.utils.toArray('.service-img-wrap').forEach(wrap => {
  const inner = wrap.querySelector('.service-img-sub-wrap');
  if (!inner) return;

  gsap.to(inner, {
    y: '-80vw', // 移動量の調整（上移動）
    ease: 'none',
    scrollTrigger: {
      trigger: wrap,
      start: 'top bottom',
      end: 'bottom top',
      scrub: 5,
    }
  });
});